import React from 'react';

import { Button, Tooltip } from "@material-ui/core";
import { DATA_SCOPES, FILTER_TYPE } from "../filterConstants";
import { DateFilter } from "../filterTypes/dateFilter";
import { ElementFilter } from "../filterTypes/elementFilter";
import { StringFilter } from "../filterTypes/stringFilter";

import NewAlert from '@material-ui/icons/Warning';
import AcknowledgedAlert from '@material-ui/icons/Visibility';
import ResolvedAlert from '@material-ui/icons/CheckCircle';
import { fetchUserAlerts, updateUserAlert } from '../../../actions/alertActions';
import { useDispatch } from 'react-redux';
import { USER_ALERT_STATUS } from '../../constants';

export class AlertStatusTextFilter extends StringFilter {
  constructor(visibility, restrictedToScope) {
    super("Alert Status Text", FILTER_TYPE.ALERT.STATUS_TEXT, [DATA_SCOPES.ALERT], null, visibility, restrictedToScope)
  }

  formatData(device, deviceGroups, insight, insightMetrics, update, alert) {
    return alert.status;
  }
}

export class AlertTypeFilter extends StringFilter {
  constructor(visibility, restrictedToScope) {
    super("Alert Type", FILTER_TYPE.ALERT.TYPE, [DATA_SCOPES.ALERT], null, visibility, restrictedToScope)
  }

  formatData(device, deviceGroups, insight, insightMetrics, update, alert) {
    return alert.alert_type;
  }
}

export class AlertSummaryFilter extends StringFilter {
  constructor(visibility, restrictedToScope) {
    super("Alert Title", FILTER_TYPE.ALERT.SUMMARY, [DATA_SCOPES.ALERT], null, visibility, restrictedToScope)
  }

  formatData(device, deviceGroups, insight, insightMetrics, update, alert) {
    return alert.summary;
  }
}

export class AlertKeyFilter extends StringFilter {
  constructor(visibility, restrictedToScope) {
    super("Associated Domain", FILTER_TYPE.ALERT.KEY, [DATA_SCOPES.ALERT], null, visibility, restrictedToScope)
  }

  formatData(device, deviceGroups, insight, insightMetrics, update, alert) {
    return alert.alert_key;
  }
}

export class AlertAssociatedIdFilter extends StringFilter {
  constructor(visibility, restrictedToScope) {
    super("Associated ID", FILTER_TYPE.ALERT.ASSOCIATED_ID, [DATA_SCOPES.ALERT], null, visibility, restrictedToScope)
  }

  formatData(device, deviceGroups, insight, insightMetrics, update, alert) {
    return alert.associated_id.toString();
  }
}

export class AlertCreatedAtFilter extends DateFilter {
  constructor(visibility, restrictedToScope) {
    super("Created At", FILTER_TYPE.ALERT.CREATED_AT, [DATA_SCOPES.ALERT], null, visibility, restrictedToScope)
  }

  formatData(device, deviceGroups, insight, insightMetrics, update, alert) {
    return alert.created_at;
  }
}

export class AlertStatusIconFilter extends ElementFilter {
  constructor(visibility, restrictedToScope) {
    super("Alert Status", FILTER_TYPE.ALERT.STATUS_ICON, [DATA_SCOPES.ALERT], null, visibility, restrictedToScope)
  }

  formatData(device, deviceGroups, insight, insightMetrics, update, alert) {
    const status = alert.status;
    let dataMap = {};
    switch (status) {
      case (USER_ALERT_STATUS.NEW): dataMap.element = (<Tooltip title="New Alert"><NewAlert style={{ color: "red" }} /></Tooltip>); dataMap.orderValue = 1; break;
      case (USER_ALERT_STATUS.ACKNOWLEDGED): dataMap.element = (<Tooltip title="Acknowledged Alert"><AcknowledgedAlert /></Tooltip>); dataMap.orderValue = 2; break;
      case (USER_ALERT_STATUS.RESOLVED): dataMap.element = (<Tooltip title="Resolved Alert"><ResolvedAlert style={{ color: "green" }} /></Tooltip>); dataMap.orderValue = 3; break;
      default: return;
    }
    return dataMap;
  }
}

export class AlertActionFilter extends ElementFilter {
  constructor(visibility, restrictedToScope) {
    super("Action", FILTER_TYPE.ALERT.ACTION, [DATA_SCOPES.ALERT], null, visibility, restrictedToScope)
    this.dispatch = useDispatch();
  }

  async setAlertStatus (id, status) {
    await updateUserAlert(id, status);
    this.dispatch(fetchUserAlerts());
  }

  formatData(device, deviceGroups, insight, insightMetrics, update, alert) {
    const status = alert.status;
    const id = alert.id;
    let dataMap = {};
    switch (status) {
      case (USER_ALERT_STATUS.NEW): dataMap.element = (<Button variant="outlined" color="primary" onClick={() => this.setAlertStatus(id, USER_ALERT_STATUS.ACKNOWLEDGED)}>Acknowledge</Button>); dataMap.orderValue = 1; break;
      case (USER_ALERT_STATUS.ACKNOWLEDGED): dataMap.element = (<Button variant="outlined" color="primary" onClick={() => this.setAlertStatus(id, USER_ALERT_STATUS.RESOLVED)}>Resolve</Button>); dataMap.orderValue = 2; break;
      case (USER_ALERT_STATUS.RESOLVED): dataMap.element = (<Button variant="outlined" color="primary" disabled>Resolved</Button>); dataMap.orderValue = 3; break;
      default: return;
    }
    return dataMap;
  }
}
